module.exports = __webpack_public_path__ + "img/trainee.a1012ce4.svg";